import { ActionTree } from "vuex";
import { IReceptionState } from "./reception-state.store";
import { IRootState } from "../root-state.store";
import * as types from "./reception-types.store";
import { IReceptionParameter, IReceptionSectionListingViewModel } from "../../models/reception";
import { ActivityStatus } from "../../common/enums";
export const actions: ActionTree<IReceptionState, IRootState> = {
  [types.RECEPTION_GET_RECEPTIONS]: async ({ commit, state }, payload: { param?: IReceptionParameter, merge?: boolean }) => {
    if (state.receptionsSource.activityStatus === ActivityStatus.Loading) return Promise.reject();
    commit(types.RECEPTION_GET_RECEPTIONS_LOADING, ActivityStatus.Loading);
    return await state.service!.getReceptions(payload && payload.param ? payload.param : state.receptionParameter, true)
      .then(response => {
        commit(types.RECEPTION_GET_RECEPTIONS,
          {
            activityStatus: ActivityStatus.Loaded,
            receptions: response.data,
            merge: (payload || {}).merge || false,
            pagination: { limit: response.limit, total: response.total, skip: response.skip }
          })
        return response.data;
      })
      .catch(error => {
        commit(types.RECEPTION_GET_RECEPTIONS_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  }
  , [types.RECEPTION_GET_RECEPTION]: async ({ commit, state }, id: string) => {

    if (state.receptionSource.activityStatus === ActivityStatus.Loading) return;
    commit(types.RECEPTION_GET_RECEPTION_LOADING, ActivityStatus.Loading);

    return await state.service!.getReceptionById(id)
      .then(response => {
        commit(types.RECEPTION_GET_RECEPTION, response)
        return response.data;
      })
      .catch(error => {
        commit(types.RECEPTION_GET_RECEPTION_LOADING, ActivityStatus.LoadFailed)
        console.log(error, 'error')
        return error
      })
  }
  , [types.RECEPTION_GET_RECEPTION_SECTIONS]: async ({ commit, state }, id: string) => {
    commit(types.RECEPTION_GET_RECEPTION_SECTIONS_LOADING, ActivityStatus.Loading)
    return await state.service!.getReceptionSectionsByReceptionId(id)
      .then(response => {
        commit(types.RECEPTION_GET_RECEPTION_SECTIONS, response.data)
        return response.data;
      })
      .catch(error => {
        commit(types.RECEPTION_GET_RECEPTION_SECTIONS_LOADING, ActivityStatus.LoadFailed)
        console.log(error, 'error')
      })
  }
  , [types.RECEPTION_GET_SECTION]: async ({ commit, state, getters }, payload: { sectionId: number, itemId: number, receptionId: number }) => {

    const sections: IReceptionSectionListingViewModel[] = getters.receptionSource.detail.sections || [];
    const section = sections.find((x: any) => x.id === payload.sectionId);
    console.log(section, sections)
    if (section) {
      return section['items'].find(x => x.id === payload.itemId) || {
        character_problem_level_2: {},
        character_problem: {},
        media: {
          link: null
        }
      };
    }
    return {
      character_problem_level_2: {},
      character_problem: {},
      media: {
        link: null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reception/reception-actions.store.ts